module.exports = "<router-outlet></router-outlet>";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/app.component.html
 ** module id = 55
 ** module chunks = 0
 **/